export default "__VITE_ASSET__DDH1EVHl__"